// extracted by mini-css-extract-plugin
export default {"rangeFields":"ConstructionYear_rangeFields__4qbqT","rangeField":"ConstructionYear_rangeField__ytMxb","dashMark":"ConstructionYear_dashMark__Pm2Uv"};